import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=47dc5c4c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=47dc5c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc5c4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47dc5c4c')) {
      api.createRecord('47dc5c4c', component.options)
    } else {
      api.reload('47dc5c4c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=47dc5c4c&scoped=true&", function () {
      api.rerender('47dc5c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GY1ken26T4ZJ/JS/comp/PopupDialog.vue"
export default component.exports